<template>
    <el-container>
        <el-header>
            <el-form @submit.native.prevent :inline="true" :model="formDbTask" ref="formTemplate" class="demo-form-inline">
                <el-form-item :label="$t('pgCommon.NAME')">
                    <td-input v-model="formDbTask.sName"></td-input>
                </el-form-item>
                <el-form-item :label="$t('pgCommon.TIME_TASK')">
                    <td-select v-model="formDbTask.sTaskId" url="/timedTaskManager/findJob" keys="jobKey" text="jobName" :urlParam="timeTaskParam" requestType="POST"></td-select>
                </el-form-item>
                <el-form-item :label="$t('pgCommon.OUTPUT_TYPE')">
                    <td-select v-model="formDbTask.iOutput" :options="dbOutputTypes" keys="id" text="name"></td-select>
                </el-form-item>
                <el-form-item :label="$t('pgCommon.DATASOURCE')">
                    <td-select v-model="formDbTask.sDataSourceId" url="/setting/databaseController/queryDbInfo" keys="id" text="caption" urlParam="" requestType="POST"></td-select>
                </el-form-item>

                <el-form-item class="paddingLeft10">
                    <td-button type="primary" :loading="loading" @click="btnClickQuery">
                        {{ $t('common.QUERY') }}
                    </td-button>
                    <td-button type="button" @click="btnAddTask">{{ $t('common.ADD') }}</td-button>
                    <td-button type="button" @click="btnDeleteTask">{{ $t('common.DELETE') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                ref="tableInfo"
                :dataSource="tableData"
                :total="total"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :rowKey="rowKey"
                :hasPage="true"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                @handleSelect="handleSelect"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-dbtask
                v-if="dialogVisible"
                :dialogVisible="dialogVisible"
                :editItem="editItem"
                :title="title"
                :outputTypes="dbOutputTypes"
                :sqlParamTypes="sqlParamTypes"
                @SmsDialogClose="SmsDialogClose"
                @submit="submit"
            ></dialog-dbtask>
        </el-main>
    </el-container>
</template>

<script>
import dialogDbTask from './components/add';
import api from './assets/api';

export default {
    props: {},
    created() {
        this.btnQuery();
        this.getDic('SQL_OUTPUT_TYPE', this.dbOutputTypes);
        this.getDic('SQL_PARAM_TYPE', this.sqlParamTypes);
    },
    // 初始化渲染
    components: {
        'dialog-dbtask': dialogDbTask
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {},
    // 定义数据
    data() {
        return {
            timeTaskParam: { sName: '' },
            formDbTask: {},
            dbOutputTypes: [],
            sqlParamTypes: [],
            editItem: {},
            dialogVisible: false,
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            rowKey: 'sId',
            columns: [
                {
                    prop: 'sName',
                    label: 'pgCommon.NAME',
                    align: 'center'
                },
                {
                    prop: 'taskName',
                    label: 'pgCommon.TIME_TASK',
                    align: 'center'
                },
                {
                    prop: 'dataSourceName',
                    label: 'pgCommon.DATASOURCE',
                    align: 'center'
                },
                {
                    prop: 'sSql',
                    label: 'pgCommon.SQL_CONTENT',
                    align: 'center'
                },
                {
                    prop: 'iSqlParamType',
                    label: 'pgCommon.SQL_PARAM_TYPE',
                    align: 'center',
                    render: (createElement, params) => {
                        let value = '';
                        for (let sqlParamType of this.sqlParamTypes) {
                            if (sqlParamType.id === params.row.iSqlParamType) {
                                value = sqlParamType.name;
                                break;
                            }
                        }
                        return createElement('span', value);
                    }
                },
                {
                    prop: 'iOutput',
                    label: 'pgCommon.OUTPUT_TYPE',
                    align: 'center',
                    render: (createElement, params) => {
                        let value = '';
                        for (let sqlParamType of this.dbOutputTypes) {
                            if (sqlParamType.id === params.row.iOutput) {
                                value = sqlParamType.name;
                                break;
                            }
                        }
                        return createElement('span', value);
                    }
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDelete([params.row.sId]);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        //获取字典数据
        getDic(param, options) {
            api.getDictValuesByTag({ sTag: param }, response => {
                response.data.content.forEach(n => {
                    let obj = {};
                    obj.id = parseInt(n.sCode);
                    obj.name = n.sValue;
                    options.push(obj);
                });
            });
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.btnQuery();
        },
        // getPermissionsStatus(permissions) {
        //     if (permissions) {
        //         this.btnQuery(); // 进行页面初始化数据的加载
        //     }
        // },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
        //查询点击按钮
        btnClickQuery() {
            this.btnQuery();
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sTaskId: this.formDbTask.sTaskId,
                sName: this.formDbTask.sName,
                iOutput: this.formDbTask.iOutput,
                sDataSourceId: this.formDbTask.sDataSourceId,
                page: this.currentPage,
                pageSize: this.pageSize
            };
            api.getListInfo(JSON.stringify(param), response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.$log.error('/dbTask/list', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/dbTask/list', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content.resultlist;
                //获取任务名称
                this.total = response.data.content.total;
                this.loading = false;
            });
        },
        // 添加
        btnAddTask() {
            this.editItem = {};
            this.title = this.$t('common.ADD'); // 标题
            this.dialogVisible = true;
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT');
            this.dialogVisible = true;
        },
        // 获取选中表格数据的id
        getTableSelectId() {
            let selectData = this.$refs.tableInfo.getSelectAllRows();
            let tableSign = [];
            for (let i = 0; i < selectData.length; i++) {
                tableSign.push(selectData[i].sId);
            }
            return tableSign;
        },
        // 批量删除
        btnDeleteTask() {
            let tableSign = this.getTableSelectId();
            if (tableSign.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_SELECT'), type: 'warning' });
                return;
            }
            this.btnDelete(tableSign);
        },
        // 删除接口
        btnDelete(sign) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    api.deleteDbTask(JSON.stringify(sign), response => {
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('smsTemplate/deleteSmsTemplate', response.data.statusMessage);
                            return;
                        }
                        this.$message({
                            showClose: true,
                            message: this.$t('common.DELETE_SUCCESS'),
                            type: 'success'
                        });
                        this.submit();
                    });
                })
                .catch(() => {});
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        SmsDialogClose() {
            this.dialogVisible = false;
        }
    }
};
</script>
